import { useEffect, useState } from 'react';
import Button from '../Button/Button';
import './LoginForm.scss';
import AlertModal from '../../components/AlertModal/AlertModal';
import { ReactComponent as Eye } from '../../assets/eye.svg';
import { ReactComponent as EyeOff } from '../../assets/eye-off.svg';

export default function LoginForm({ onLogin, loading, error, onForgot, info }) {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [formState, setFormState] = useState('login');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    onLogin({ username, password });
  };

  const handleForgotSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    if (!email) return;
    onForgot?.(email);
  };

  useEffect(() => {
    if (error) {
      setOpenModal(true);
      setPassword('');
    }
  }, [error]);

  useEffect(() => {
    if (info) setOpenModal(true);
  }, [info]);

  return (
    <>
      {formState === 'login' ? (
        <form onSubmit={handleSubmit} className="auth-form">
          {openModal && (error || info) && (
            <AlertModal
              title="Aviso"
              variant={error ? 'danger' : 'info'}
              message={error || info}
              onClose={() => setOpenModal(false)}
            />
          )}

          <div className="row">
            <label className="label">Username</label>
            <input
              placeholder="Username"
              className="input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
              autoComplete="username"
            />
          </div>
          <div className="row">
            <label className="label">Password</label>
            <input
              placeholder="Password"
              className="input"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              autoComplete="current-password"
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <EyeOff /> : <Eye />}
            </button>
          </div>
          <div className="recover-password">
            <button type="button" onClick={() => setFormState('recover')}>
              Recuperar password
            </button>
          </div>
          <div className="buttons">
            <Button type="submit" disabled={loading}>
              Entrar
            </Button>
          </div>
        </form>
      ) : (
        <form onSubmit={handleForgotSubmit} className="auth-form">
          {openModal && (error || info) && (
            <AlertModal
              title="Aviso"
              variant={error ? 'danger' : 'info'}
              message={error || info}
              onClose={() => setOpenModal(false)}
            />
          )}

          <div className="row">
            <label className="label">Email</label>
            <input
              placeholder="Email"
              className="input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              autoComplete="email"
            />
          </div>
          <div className="recover-password">
            <button type="button" onClick={() => setFormState('login')}>
              Voltar para o Login
            </button>
          </div>
          <div className="buttons">
            <Button type="submit" disabled={loading}>
              Enviar link
            </Button>
          </div>
        </form>
      )}
    </>
  );
}
